module.exports = __webpack_public_path__ + "img/clareamento.b1b70af5.png";